import { render } from "./imgDialog.vue?vue&type=template&id=8647761e"
import script from "./imgDialog.vue?vue&type=script&lang=js"
export * from "./imgDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__